<template>
  <page-wrapper :title="title" :hasPad="true">
    <div class="container">
      <sc-button variant="danger" @click="handleClickRemove">ลบ</sc-button>
      <ruejai-club-banner-editor
        class="mt-4"
        v-model="form"
        :imageUrl="imageUrl"
      ></ruejai-club-banner-editor>
      <div class="text-right">
        <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import RuejaiClubBannerEditor from "../components/RuejaiClubBannerEditor";
import { baanRueJaiClient } from "@/dependencies";
import { uploadImage, getPublicImageUrl } from "@/god";
import { DateTime } from "luxon";

export default {
  components: {
    PageWrapper,
    ScButton,
    RuejaiClubBannerEditor
  },
  data() {
    const title = "รายละเอียด Ruejai Club Banner";
    const imageUrl = "";
    const form = {
      imageFile: null,
      title: "",
      ruejaiClubPackageId: null
    }

    return {
      title,
      form,
      imageUrl
    };
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      this.setupData();
    },
    async setupData() {
      const {
        title,
        ruejai_club_package_id: ruejaiClubPackageId,
        image_url: imageUrl
      } = await this.fetchBanner();

      this.form = {
        title,
        ruejaiClubPackageId,
        imageFile: null
      };
      this.imageUrl = imageUrl;
    },
    async fetchBanner() {
      const { id } = this.$route.params;
      const response = await baanRueJaiClient.admin.ruejaiClub.banners.get(
        id
      );

      return response.data.result;
    },
    async handleClickSave() {
      try {
        await this.updateBanner();
        this.$router.push({ name: "RuejaiClubBannerListPage" });
      } catch (err) {
        console.error(err);
        alert("ไม่สามารถสร้างบันทึก Banner ได้");
      }
    },
    async updateBanner() {
      const { id } = this.$route.params;
      const {
        title,
        ruejaiClubPackageId,
        imageFile
      } = this.form;

      const params = {
        title,
        ruejai_club_package_id: ruejaiClubPackageId,
        image_url: this.imageUrl
      };

      if (imageFile) {
        const imageUrl = await this.uploadPublicImage(imageFile);
        params.image_url = imageUrl;
      }

      await baanRueJaiClient.admin.ruejaiClub.banners.put(id, params);
    },
    async handleClickRemove() {
      if (!confirm("ยืนยันการลบ")) {
        return;
      }

      try {
        await this.removeBanner();
        alert("ลบเรียบร้อย");
        this.$router.push({ name: "RuejaiClubBannerListPage" });
      } catch (err) {
        alert("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
        console.error(err);
      }
    },
    async removeBanner() {
      const { id } = this.$route.params;

      await baanRueJaiClient.admin.ruejaiClub.banners.delete(id);
    },
    async uploadPublicImage(file) {
      const image = await uploadImage(file, file.name, "article");
      const { url } = await getPublicImageUrl(image);

      return url;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
</style>



// WEBPACK FOOTER //
// src/features/ruejai-club/modules/banner/pages/RuejaiClubBannerDetailPage.vue